export const BASE_URL = 'https://vikramshilaedu.in/';
export const SERVER_URL = "https://vikramshilaedu.in/";
